import React from "react";
import Header from "../../../layouts/header/Header";
import HeadingComponent from "./HeadingComponent";
import Footer from "../../../layouts/footer/Footer";
import Scroller from "./ScrollerStaticPage";
import { TablistStaticPages } from "./TablistStaticPages";
interface StaticPageData {
  title?: string;
  children?: React.ReactNode;
}

interface props {
  heading?: string;
  subheading?: string;
  textContentData?: StaticPageData[];
  scrollerTopContent?: React.ReactNode;
}
export default function LayoutStaticPage({
  heading,
  subheading,
  textContentData,
  scrollerTopContent,
}: props) {
  return (
    <>
      <Header />
      <HeadingComponent heading={heading} subheading={subheading} />
      <Scroller
        className="hidden lg:flex"
        textContentData={textContentData}
        children={scrollerTopContent}
      />
      <TablistStaticPages
        className="lg:hidden"
        textContentData={textContentData}
      />
      <Footer />
    </>
  );
}
